import { TranslateService } from '@ngx-translate/core';

import { RouteCodeEnum } from '@models/menu';

/**
 * Label for a menu item: system modules by `code` (`moduleNames.<code>`),
 * folders by name (`menuFolders.<name>`). Missing key → backend `name`,
 * so English (no translation blocks) and custom items keep their `name`.
 */
export function resolveModuleLabel(item: { code?: RouteCodeEnum; name?: string }, translate: TranslateService): string {
  const name = item?.name ?? '';
  if (!name) {
    return '';
  }
  const key = item?.code ? `moduleNames.${item.code}` : `menuFolders.${name}`;
  const translated = translate.instant(key);
  return !translated || translated === key ? name : translated;
}
